@if (downPayment(); as downPayment) {
  <div
    class="card mt-5 flex flex-wrap lg:flex-nowrap justify-between items-center"
  >
    <div class="w-full flex flex-wrap gap-2 lg:gap-0 items-center">
      <div
        [innerHTML]="getInstallmentStatusComponent(downPayment.status)"
        class="w-fit mr-3"
      ></div>
      <div
        class="w-full lg:w-[70%] flex flex-wrap lg:flex-nowrap gap-2 lg:gap-6"
      >
        @if (latestPayment(); as payment) {
          <div class="w-full lg:w-fit">
            <p>Data</p>
            <p class="font-bold">
              {{ payment.date | date: "dd/MM/yyyy HH:mm" }}
            </p>
          </div>
          <div class="w-full lg:w-fit">
            <p>Método de Pagamento</p>
            <p class="font-bold">{{ payment.method }}</p>
          </div>
          <div class="w-full lg:w-fit">
            <p>Dados do Pagamento</p>
            <p class="font-bold">
              @if (payment.card) {
                {{ payment.card.brand | titlecase }} ••••
                {{ payment.card.displayNumber }}
              } @else {
                -
              }
            </p>
          </div>
        }
        <div class="w-full lg:w-fit">
          <p>Valor</p>
          <p class="font-bold">{{ downPayment.totalAmount | currency }}</p>
        </div>
        @if (downPayment.invoice) {
          <div class="w-full lg:w-fit">
            <p>Invoice</p>
            <a
              [href]="downPayment.invoice.invoiceUrl"
              target="_blank"
              class="text-blue-600 hover:underline"
            >
              <i class="ph ph-scroll"></i>
              Visualizar
            </a>
          </div>
        }
      </div>
    </div>
    @if (hasPayments()) {
      <div class="hidden lg:block w-fit mr-10">
        <p-button
          type="button"
          icon="ph ph-eye"
          [rounded]="true"
          styleClass="btn-purple-outline"
          (click)="paymentsDialogVisible.set(true)"
          pTooltip="Detalhes do pagamento"
          tooltipPosition="top"
          tooltipStyleClass="whitespace-nowrap"
        />
      </div>
      <div class="w-full flex justify-end lg:hidden">
        <p-button
          type="button"
          label="Ver detalhes"
          styleClass="btn-purple-link"
          (click)="paymentsDialogVisible.set(true)"
        />
      </div>
    }
  </div>

  <app-order-installment-payments-dialog
    [(visible)]="paymentsDialogVisible"
    [installment]="downPayment"
    [order]="order()"
  />
} @else {
  <p class="text-center mt-5">Este pedido não possui taxa de inscrição.</p>
}
